export function initShare() {
  document.addEventListener("click", (e) => {
    const link = e.target.closest("a[data-share]")
    if (!link) return

    e.preventDefault()
    const w = 640
    const h = 480
    const left = window.screenX + (window.outerWidth - w) / 2
    const top = window.screenY + (window.outerHeight - h) / 2
    window.open(
      link.href,
      "share",
      `width=${w},height=${h},left=${left},top=${top},noopener,noreferrer`,
    )
  })
}
